<template>
  <div class="bulk-container">
    <div class="title" role="heading" aria-level="3">Bulk actions:</div>
    <button
      v-for="action in actions"
      :key="action.id"
      type="button"
      class="bulk-action-button"
      :aria-label="getActionLabel(action)"
      @click="clickedAction(action)"
    >
      <i :class="action.icon" aria-hidden="true"></i>
      {{ action.text }}
    </button>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n"

export default {
  props: {
    actions: {
      type: Array,
      required: true
    }
  },

  emits: ["clickAction"],
  setup(props, { emit }) {
    const { t } = useI18n()

    const getActionLabel = (action) => {
      const actionText = action?.text?.trim?.()
      if (actionText) return actionText
      const actionId = action?.id ? String(action.id) : ""
      return actionId
        ? t("common.a11y_bulk_action_with_id", { id: actionId })
        : t("common.a11y_bulk_action")
    }

    const clickedAction = (action) => {
      emit("clickAction", action)
    }

    return {
      props,
      getActionLabel,
      clickedAction
    }
  }
}
</script>
<style lang="scss" scoped>
@import "src/assets/scss/_variables";
@import "src/assets/v3scss/_variables";
.bulk-container {
  display: flex;
  margin-top: 4px;
  position: relative;
  z-index: 0;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.25rem 0.35rem;
  .title {
    margin-top: 6px;
    font-size: 12px;
  }
  .bulk-action-button {
    margin-left: 0;
    font-size: 14px;
    font-family: inherit;
    color: inherit;
    line-height: inherit;
    cursor: pointer;
    border: 0;
    background: transparent;
    padding: 2px 4px;
    min-height: 2.25rem;
    display: inline-flex;
    align-items: center;
    column-gap: 4px;
    position: relative;
    i {
      color: $base-blue;
      font-size: large !important;
    }

    &:focus-visible {
      outline: 2px solid $focus-outline-color;
      outline-offset: 2px;
      border-radius: 4px;
      box-shadow:
        0 0 0 2px #fff,
        0 0 0 4px $focus-outline-color;
      z-index: 2;
    }
  }
}
</style>
